import { AxiosError } from 'axios';
import { PUT_GSC_SUBMIT_REQUEST_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutSubmitRequest = ({ uuid, onSuccess, onError }: Input) => {
  const putSubmitRequest = async () => {
    await axiosClient.put(PUT_GSC_SUBMIT_REQUEST_URL(uuid));
  };

  return useCustomMutation(putSubmitRequest, {
    onSuccess,
    onError,
  });
};
